import { Component, OnInit, ViewChild} from '@angular/core';
import { DateService } from '../services/date.service';
import {GeneralService} from "../services/general.service";
import {ActionsService} from "../services/actions.service";
import { ActivatedRoute } from '@angular/router';
import { MatSelectionList } from '@angular/material/list';
@Component(
  {
    selector: 'app-planning',
    templateUrl: './planning.component.html',
    styleUrls: ['./planning.component.scss']
  })
export class PlanningComponent implements OnInit 
{
  public urlPersonnel = this.generalService.urlSelectPerso;
  public urlAction: string = this.generalService.urlListAction;
  val1="Salarié";
  val2="Action";
  actionTab;
  actionTabFilterd;
  actionDetailTab;
  date_Debut: Date;//contein la valeur du balise html date debut
  date_Fin: Date;//contein la valeur du balise html date fi
  selectedMonthsTab: Array<any>;
  selectedWeekTab: Array<any>;
  numberDay: number;
  numCol: number;
  colSpanMonth: number;
  test: boolean;
  daysSelected: string[];
  daysSelected2: string[];
  daysSelected3: string[];
  daysSelected4: string[];
  daysSelected5: string[];
  
  tableContentPersonnel: Array<Array<contentTabFormat>>;
  tableContentAction: Array<Array<contentTabFormat>>;
  personnelTab: any;
  personnelTabFiltred;
  personnelTab2: string[];
  actionTab2: string[];
  personnelDetailTab: any;
  personnelNumber: number;
  actionNumber: number;
  searchText: string;
  avtActionDFilted; 
  selectionPersonnel; 
  selectionAction;
  selectionTypeAction;
  hideProgress = true;
  param;
  @ViewChild("typeActionSelected",{static : false}) typeActionSelected : MatSelectionList;
  @ViewChild("actionsSelected",{static : false}) actionsSelected : MatSelectionList;
  @ViewChild("personnelsSelected",{static : false}) personnelsSelected : MatSelectionList;
  typeActionTab = [];
  listeAction = [];
  listeActionActionD = [];
  typeActionTabIsLoadet : boolean = false;
  personnelTabIsloadet : boolean = false;
  constructor(public dateService: DateService,public actionsService: ActionsService,public generalService: GeneralService,public route: ActivatedRoute) { }
  async ngOnInit() 
  {
    this.readParamUrl();
    this.setTypeAction();
  }
  async init()
  {
    var date = new Date();
    this.date_Debut = new Date(date.getFullYear(),date.getMonth(),1);
    this.date_Fin= new Date(date.getFullYear(),date.getMonth(),this.dateService.getLastDayOfMonth(date.getMonth()));
    this.test = false;
    this.personnelDetailTab =[];
    this.actionDetailTab = []; 
    this.setPersonnel(); 
    this.getActionD()
  }
  setTypeAction()
  {
    this.generalService.rechercheTable(this.generalService.urlListeParamAction).subscribe(paramAction =>
    {
      this.typeActionTab = paramAction//.filter(type => {return type.avtParamAction_Default == "2"});
      this.typeActionTabIsLoadet = true;
      setTimeout(()=>
      {
        this.selectAllTypeAction();
      },100)
    })
  }
  filterPersonnelTab()
  {
    if(this.generalService.isNotEmpty(this.generalService.collaborateurConnecter))
    {
      this.personnelTab = this.personnelTab.filter( coll =>
      {
        return this.generalService.collaborateurConnecter.localeCompare(coll.Perso_Matricule)===0;
      });
      this.personnelTab = this.generalService.sort(this.personnelTab,"Perso_Nom")
      setTimeout(()=>
      {
        this.selectAllCollaboteur();
      },100)
    }
    else
    {
      setTimeout(()=>
      {
        this.filterPersonnelTab()
      },100)
    }
  }
  setPersonnel()
  {
    this.generalService.rechercheTable(this.generalService.url + "avtperso&param=0").subscribe( perso =>
    {
      this.personnelTab = perso//.filter(c =>{return c.Perso_TypePerso !="2" && c.Perso_TypePerso !="10"}); ;
      if( "mon_planning".localeCompare(this.param) === 0)
      {
        this.filterPersonnelTab();
      }
      else
      {
        this.personnelTab = this.generalService.sort(this.personnelTab,"Perso_Nom");
        setTimeout(()=>
        {
          this.selectAllCollaboteur();
        },100)
      }
      this.personnelTabIsloadet = true;
      
    });
  }
  setAction()
  {
    var listeCodeColl: string="";
    this.personnelTab.forEach(perso => 
    {
      listeCodeColl+=perso.Perso_Matricule+";"
    });
    this.generalService.rechercheTable(this.generalService.urlListeActionCol+listeCodeColl).subscribe( action => 
    {
      this.listeAction = this.generalService.sort(action,"avtAction_Intitule");     
      this.dateChange();
    });
  }
  dateChange()
  {
    // this.actionTab = this.listeAction.filter(action =>
    // {
    //   return this.dateService.dateInclueDansInterval(this.date_Debut,this.date_Fin,action.avtAction_dateDeb) ||
    //          this.dateService.dateInclueDansInterval(this.date_Debut,this.date_Fin,action.avtAction_dateFin)
    // })
    // this.actionTab = this.generalService.sort(this.actionTab,"avtAction_Intitule"); 
  }
  async getActionD()
  {
    var dateDebut: string=this.dateService.setFormatDateRechercheServer(this.date_Debut);
    var dateFin: string=this.dateService.setFormatDateRechercheServer(this.date_Fin);
    var url = "";
    if( "mon_planning".localeCompare(this.param) === 0)
      var url = this.generalService.url + "avtActionlpc&param=" +dateDebut+","+dateFin+"," + this.generalService.collaborateurConnecter + ",%";
    else
    var url = this.generalService.url + "avtActionlpc&param=" +dateDebut+","+dateFin+",%,%";
    var avtActionD = await this.generalService.rechercheTable(url).toPromise();
    
    this.listeActionActionD = avtActionD;
    this.genererAction();
    return avtActionD ;
  }
  
  genererAction()
  {
    this.actionTab = []
    var distinctAvtAction_Code = this.generalService.distinct(this.listeActionActionD, "avtAction_Code")
    distinctAvtAction_Code.forEach(action =>
    {
      this.actionTab.push(this.listeActionActionD.find(findAction =>{return findAction.avtAction_Code== action}))
    });
    setTimeout(()=>
    {
      this.selectAllAction();
    },100)
  }
  deSelectAllCollaboteur()
  {
    this.personnelsSelected.deselectAll();
    this.onSelectionPersonnel([])
  }
  selectAllCollaboteur()
  {
    this.personnelsSelected.selectAll()
    this.onSelectionPersonnel(this.personnelsSelected.selectedOptions.selected)
  }
  onSelectionPersonnel(liste)
  {
    this.selectionPersonnel =";";
    liste.forEach(element => 
    {
      this.selectionPersonnel +=element.value+";"
    });
  }
  onSelectionAction(liste)
  {
    this.selectionAction = ";";
    liste.forEach(element => 
    {
      this.selectionAction +=element.value+";"
    });
  }
  deSelectAllAction()
  {
    this.actionsSelected.deselectAll();
    this.onSelectionAction([])
  }
  selectAllAction()
  {
    this.actionsSelected.selectAll()
    this.onSelectionAction(this.actionsSelected.selectedOptions.selected)
  }
  onSelectionTypeAction(liste)
  {
    this.selectionTypeAction =";";
    liste.forEach(element => 
    {
      this.selectionTypeAction +=element.value+";"
    });
  }
  deSelectAllTypeAction()
  {
    this.typeActionSelected.deselectAll();
    this.onSelectionTypeAction([])
  }
  selectAllTypeAction()
  {
    this.typeActionSelected.selectAll()
    this.onSelectionTypeAction(this.typeActionSelected.selectedOptions.selected)
  }
  setActionDetailTab()
  {
    this.actionDetailTab=[];    
    if(this.selectionAction !=";" && this.selectionAction!=undefined && this.selectionTypeAction !=";" && this.selectionTypeAction!=undefined)
    {
      this.actionTabFilterd = this.actionTab.filter(action =>
      {
        return this.selectionAction.indexOf(";"+action.avtAction_Code+";")>=0;
      });
      this.actionTabFilterd = this.actionTabFilterd.filter(action =>
      {
        return this.selectionTypeAction.indexOf(";"+action.avtActionD_Type+";")>=0;
      });
      this.actionNumber = this.actionTabFilterd.length;
    }
    else
    {
      this.actionTabFilterd = [];
      this.actionNumber = 0;
    }
    
    for(var i =1; i<this.numberDay+1;i++)
    {
      var date = new Date(this.date_Debut.getFullYear(),this.date_Debut.getMonth(),1 );    
      date.setDate(i) ;
      var d= this.dateService.setToFormatDateServerStr(date);
      this.actionTabFilterd.forEach(action => 
      {
        var actionDetailTabBrut = this.avtActionDFilted.filter(avtActionD =>
        {
          return avtActionD.avtAction_Code == action.avtAction_Code && d == ( this.dateService.setToFormatDateServerStr(avtActionD.avtActionD_date));
        });
        if(actionDetailTabBrut.length >0)
          this.fillTab(actionDetailTabBrut,this.actionDetailTab,action.avtAction_Code,date,false);        
      });
    }
  }
  setPersonnelDetailTab()
  {    
    this.personnelDetailTab = [];
    if(this.selectionPersonnel !=";" && this.selectionPersonnel!=undefined)
    {
      this.personnelTabFiltred = this.personnelTab.filter(personnel => 
      {
        return this.selectionPersonnel.indexOf(";"+personnel.Perso_Matricule+";")>=0
      })
      this.personnelNumber = this.personnelTabFiltred.length;
    }
    else
    {
      this.personnelTabFiltred = [];
      this.personnelNumber = 0;
    }
    for(var i =1; i<this.numberDay+1;i++)
    {
      var date = new Date(this.date_Debut.getFullYear(),this.date_Debut.getMonth(),1 );   
      date.setDate(i) ;   
      var d= this.dateService.setToFormatDateServerStr(date);
      this.personnelTabFiltred.forEach(personnel => 
      {
        var personnelDetailTabBrut = this.avtActionDFilted.filter(avtActionD =>
        {
          return avtActionD.Perso_Matricule == personnel.Perso_Matricule && d == this.dateService.setToFormatDateServerStr( avtActionD.avtActionD_date);
        });
        if(personnelDetailTabBrut.length >0)
          this.fillTab(personnelDetailTabBrut,this.personnelDetailTab,personnel.Perso_Matricule,date,false);
      });
    }
  }
  fillTab(DetailTabBrut,detailTab,code,date,enConge)
  {
    var numberHeur =0;
    numberHeur = this.actionsService.getNbrHeure(DetailTabBrut)   ;
    detailTab.push({code: code,date:this.dateService.setFormatDate(date),numberHeur:numberHeur,enConge:enConge });
  }
  switchMode()
  {
    var t = new Array(4);
    t[0] = this.tableContentAction;
    t[1] = this.tableContentPersonnel;
    t[2] = this.val1;
    t[3] = this.val2;
    this.val1 = t[3];
    this.val2 = t[2];
    this.tableContentAction = t[1];
    this.tableContentPersonnel = t[0];
  } 
  async setTable() 
  {
    if (this.date_Debut != null && this.date_Fin != null && this.date_Debut.getTime() < this.date_Fin.getTime() ) 
    {
      this.hideProgress = false;
      this.test = false;
      this.numberDay = this.dateService.dateDiff(this.date_Debut, this.date_Fin); 
      this.avtActionDFilted = await this.getActionD();
      setTimeout(()=>
      {
        this.setActionDetailTab();
        this.setPersonnelDetailTab();
        this.selectedMonthsTab = this.dateService.getListMonth(this.date_Debut, this.date_Fin, this.numberDay);
        this.fillSelectedWeekToTab();
  
        this.tableContentPersonnel = this.initialiserTable(this.personnelNumber, this.tableContentPersonnel);
        var t = this.fillFirstColTableContent(this.tableContentPersonnel, this.personnelTab2, this.personnelTabFiltred, this.personnelNumber,"Perso_Nom","Perso_Matricule");
        this.tableContentPersonnel = t[0];
        this.personnelTab2 = t[1];
        this.tableContentPersonnel = this.setTableContent(this.personnelNumber,
                                                          this.tableContentPersonnel,
                                                          this.personnelDetailTab,
                                                          this.personnelTab2);
        this.tableContentPersonnel = this.setSommeHeurs(this.tableContentPersonnel,this.personnelNumber);
        this.tableContentPersonnel = this.setTautoxHeurs(this.tableContentPersonnel,this.personnelNumber);
        //////////////////////////////////////////
        this.tableContentAction = this.initialiserTable(this.actionNumber, this.tableContentAction);
        t = this.fillFirstColTableContent(this.tableContentAction, this.actionTab2, this.actionTabFilterd, this.actionNumber,"avtAction_Intitule","avtAction_Code")
        this.tableContentAction = t[0];
        this.actionTab2 = t[1];
        this.tableContentAction = this.setTableContent( this.actionNumber,
                                                        this.tableContentAction,
                                                        this.actionDetailTab,
                                                        this.actionTab2);
        this.tableContentAction = this.setSommeHeurs(this.tableContentAction,this.actionNumber);
        this.tableContentAction = this.setTautoxHeurs(this.tableContentAction,this.actionNumber);
        this.hideProgress = true;
        this.test = true;
      },110)
      
    }
    else
    this.generalService.dialogSuccess("La date de debut doit etre inferieur au date de fin",false)
  }

  setTableContent(numberLigne, tableContent, detailTab, ligneTab2) 
  {
    detailTab.forEach(detail => 
    {
      var y=0;
      var x=0;
      x= (this.dateService.dateDiff(this.date_Debut,this.dateService.convertStrToDate(detail.date) )-1);
      
      // console.log(detail.date+"  "+x);
      
      x+=2;
      y = ligneTab2.findIndex(i => {return i== detail.code})+1;  
      tableContent[y][x].content=detail.numberHeur;    
      tableContent[y][x].color = "#7985f1"
    });
    for (var j = 0; j < this.numberDay; j++) 
    {
      var date_Debut2 = new Date(this.date_Debut);
      date_Debut2.setDate(date_Debut2.getDate()+ j);
      //pour colorier samedi et dimanche
      if (date_Debut2.getDay() == 6 || date_Debut2.getDay() == 0) 
      {        
        for(var y=1; y<numberLigne +1 ;y++)
        {
          tableContent[y][j+2].color = "#d6d6d6";
          tableContent[y][j+2].content = (date_Debut2.getDay() == 6? "SA" : "DI");
          // tableContent[y][x+1].color = "rgb(29, 250, 0)";
          // tableContent[y][x+1].content = "JF";
        }
      }
    }
    return tableContent;
  }
  setTautoxHeurs(tableContent,ligneNumber) 
  {
    for (var j = 1; j < this.numberDay + 2; j++) 
    {
      var compt = 0;
      for (var i = 0; i < ligneNumber + 1; i++) 
      {
        if (Number(tableContent[i][j].content) >= 0)
          compt += Number(tableContent[i][j].content);
      }
      tableContent[0][j].content = compt.toString();
    }
    return tableContent;
  }
  setSommeHeurs(tableContent,ligneNumber) 
  {
    for (var i = 0; i < ligneNumber + 1; i++) 
    {
      var compt = 0;
      for (var j = 2; j < this.numberDay+ 2; j++) 
      {
        if (Number(tableContent[i][j].content) >= 0)
          compt += Number(tableContent[i][j].content);
      }
      tableContent[i][1].content = compt.toString();
    }
    return tableContent;
  }
  fillFirstColTableContent(tableContent, ligneTab2, ligneTab, ligneNumber,name,code) 
  {
    var myContent1 = new contentTabFormat();
    myContent1.content = "Totaux";
    tableContent[0][0] = myContent1;
    ligneTab2 = new Array(ligneTab.length)
    for (var i = 1; i < ligneNumber + 1; i++) 
    {
      var myContent = new contentTabFormat();
      eval("myContent.content = ligneTab[i - 1]."+name);
      eval("ligneTab2[i - 1] = ligneTab[i - 1]."+code);
      tableContent[i][0] = myContent;
    }
    var t = new Array(2);
    t[0] = tableContent;
    t[1] = ligneTab2;
    return t;
  }
  initialiserTable(ligneNumber, tableContent) 
  {
    tableContent = new Array(ligneNumber + 1);
    for (var i = 0; i < ligneNumber + 1; i++) 
    {
      tableContent[i] = new Array(this.numberDay  + 2);
    }
    for (var i = 0; i < ligneNumber + 1; i++) 
    {
      for (var j = 0; j < this.numberDay  + 2; j++) 
      {
        tableContent[i][j] = new contentTabFormat();
      }
    }
    return tableContent;
  }
  fillSelectedWeekToTab() 
  {
    var week = this.getWeekTab();
    this.selectedWeekTab = this.dateService.initialiserTab(this.selectedWeekTab, week[0].length);
    var wekColspanTabs = week[1];
    var weekTabs = week[0];
    for (var i = 0; i < this.selectedWeekTab.length; i++) 
    {
      this.selectedWeekTab[i].monthName = weekTabs[i];
      this.selectedWeekTab[i].colSpan = wekColspanTabs[i];
    }
  }
  getWeekTab() 
  {
    this.daysSelected = new Array(this.numberDay);
    this.daysSelected2 = new Array(this.numberDay);
    this.daysSelected3 = new Array(this.numberDay);
    this.daysSelected4 = new Array(this.numberDay * 2);
    this.daysSelected5 = new Array(this.numberDay * 2);
    this.colSpanMonth = this.numberDay % this.selectedMonthsTab.length;
    var wekStr = "S" + this.dateService.getWeekNumber(this.date_Debut).toString();
    var actuelWek = this.dateService.getWeekNumber(this.date_Debut).toString();
    var myDate = new Date(this.date_Debut.getFullYear(), this.date_Debut.getMonth(), this.date_Debut.getDate());
    var wekTab;
    var wekColspan = "";
    var som = 0;
    var compt = 0;
    var test: boolean;
    test = false;
    var weekday = ['DI', 'LU', 'MA', 'ME', 'JE', 'VE', 'SA'];
    var ass = "";
    for (var i = 0; i < this.numberDay; i++) 
    {
      this.daysSelected[i] = myDate.getDate().toString();
      this.daysSelected2[i] = weekday[myDate.getDay()];
      this.daysSelected3[i] = myDate.toString();
      this.daysSelected4[i * 2] = weekday[myDate.getDay()];
      this.daysSelected4[i * 2 + 1] = weekday[myDate.getDay()];
      this.daysSelected5[i * 2] = myDate.toString();
      this.daysSelected5[i * 2 + 1] = myDate.toString();
      if (actuelWek != this.dateService.getWeekNumber(myDate).toString()) 
      {
        test = true;
        wekColspan += compt + ";"
        actuelWek = this.dateService.getWeekNumber(myDate).toString();
        wekStr += ";S" + actuelWek;
        compt = 0;

      }
      myDate.setDate(myDate.getDate() + 1)
      compt++;
    }
    if (!test)
      wekColspan += (compt + 1) + ";"
    else
      wekColspan += (compt + 1) + ";"
    wekTab = wekStr.split(";");
    return [wekTab, wekColspan.split(";")];
  }
  readParamUrl()
  {
    this.route.params.subscribe(params => 
    {
      this.param = params['param'];
      this.init();
    });
  }
}
class contentTabFormat 
{
  content: string;
  color: string;
}
